var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0364B8",
    fillRule: "nonzero",
    d: "M21.446 1.5H8.553C7.97 1.5 7.5 1.97 7.5 2.553V3.75L14.767 6l7.732-2.25V2.553c0-.582-.472-1.053-1.053-1.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A2767",
    fillRule: "nonzero",
    d: "M23.736 13.053c.11-.345.198-.697.263-1.054a.5.5 0 00-.25-.432l-.01-.006-.003-.001-8.128-4.63a1.127 1.127 0 00-1.218-.001L6.262 11.56l-.003.001-.009.005a.501.501 0 00-.25.432c.065.357.152.709.262 1.054l8.619 6.303 8.855-6.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A8EA",
    fillRule: "nonzero",
    d: "M17.999 3.75h-5.25L11.234 6l1.515 2.25 5.25 4.499h4.5V8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    fillRule: "nonzero",
    d: "M7.5 3.75h5.249v4.5H7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50D9FF",
    fillRule: "nonzero",
    d: "M17.999 3.75h4.5v4.5h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0364B8",
    fillRule: "nonzero",
    d: "M17.999 12.749l-5.25-4.499H7.5v4.499l5.249 4.5 8.124 1.326z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.523 3.75h14.976"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    fillRule: "nonzero",
    d: "M12.749 8.25h5.25v4.499h-5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#064A8C",
    fillRule: "nonzero",
    d: "M7.5 12.749h5.249v4.5H7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    fillRule: "nonzero",
    d: "M17.999 12.749h4.5v4.5h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A2767",
    fillRule: "nonzero",
    d: "M15.142 18.912l-8.845-6.45.372-.652 8.181 4.66c.102.04.216.037.315-.01l8.2-4.672.371.652-8.594 6.472z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1490DF",
    fillRule: "nonzero",
    d: "M23.749 12.432l-.01.006-.003.002-8.128 4.63a1.125 1.125 0 01-1.095.068l2.83 3.796 6.19 1.347v.003c.293-.211.466-.55.466-.91v-9.375a.499.499 0 01-.25.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M23.999 21.374v-.554l-7.487-4.265-.904.515a1.125 1.125 0 01-1.095.068l2.83 3.796 6.19 1.347v.003c.293-.211.466-.55.466-.91z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M23.961 21.661l-8.207-4.674-.146.082a1.125 1.125 0 01-1.095.07l2.83 3.795 6.19 1.347v.003c.21-.152.362-.372.428-.622z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A8EA",
    fillRule: "nonzero",
    d: "M6.262 12.442v-.008h-.007l-.023-.015a.486.486 0 01-.232-.42v9.375a1.126 1.126 0 001.125 1.125h15.749c.093-.001.187-.014.277-.038a.457.457 0 00.135-.045.792.792 0 00.218-.112c.015-.008.022-.008.03-.023l-17.272-9.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M13.5 18.5V6.25a1.003 1.003 0 00-1-1H7.522v5.591l-1.26.719-.004.001-.009.006a.5.5 0 00-.25.432v.004V12v7.5h6.5a1.002 1.002 0 001-1z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12.75 19.25V7a1.003 1.003 0 00-1-1H7.522v4.841l-1.26.719-.004.001-.009.006a.5.5 0 00-.25.432v.004V12v8.25h5.75a1.002 1.002 0 001-1z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12.75 17.75V7a1.003 1.003 0 00-1-1H7.522v4.841l-1.26.719-.004.001-.009.006a.5.5 0 00-.25.432v.004V12v6.75h5.75a1.002 1.002 0 001-1z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12 17.75V7a1.003 1.003 0 00-1-1H7.522v4.841l-1.26.719-.004.001-.009.006a.5.5 0 00-.25.432v.004V12v6.75h5a1.002 1.002 0 001-1z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    fillRule: "nonzero",
    d: "M1 6h10a1 1 0 011 1v10a1 1 0 01-1 .999H1a1 1 0 01-1-1V7a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M2.9 10.1a3.135 3.135 0 011.232-1.36 3.723 3.723 0 011.957-.49 3.463 3.463 0 011.81.465c.517.307.933.759 1.198 1.3.289.595.433 1.25.42 1.912a4.42 4.42 0 01-.433 1.999c-.27.56-.7 1.027-1.233 1.345a3.599 3.599 0 01-1.88.478 3.54 3.54 0 01-1.85-.47 3.153 3.153 0 01-1.213-1.302 4.097 4.097 0 01-.426-1.89A4.544 4.544 0 012.9 10.1zm1.313 3.194c.141.358.381.668.692.895.316.222.696.336 1.082.326.411.016.817-.102 1.156-.336.307-.227.54-.54.672-.898.148-.4.22-.823.215-1.249a3.799 3.799 0 00-.203-1.264 1.994 1.994 0 00-.65-.93 1.788 1.788 0 00-1.144-.355 1.87 1.87 0 00-1.108.33c-.317.227-.562.54-.708.902a3.582 3.582 0 00-.005 2.58v-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.999v23.999H0z"
  }))));
}

export default SvgOutlook;